<div class="modal-header">
  <h4 class="modal-title">Select A City</h4>
  <button unity-button class="close" classes="icon-only icon-only-large on_dark" type="button" (click)="cancelSelection()">
    <svg class="unity-icon unity-icon-times">
      <use xlink:href="#unity-icon-times"></use>
    </svg>
  </button>
</div>
<div class="modal-body" style="font-size: 14px">
  <table class="table table-select table-fixed-header">
    <tr>
      <th>Preferred City</th>
      <th>City</th>
      <th>County</th>
      <th>State</th>
    </tr>
    <tr *ngFor="let option of options; index as i" (click)="app.getSelectedText() && onSelect(option)">
      <td>
        <span *ngIf="i === 0">Yes</span>
      </td>
      <td>
        {{ option }}
      </td>
      <td>{{ county }}</td>
      <td>{{ state }}</td>
    </tr>
  </table>
</div>
<div class="modal-footer">
  <button unity-button type="button" (click)="cancelSelection()" classes="primary">Cancel</button>
</div>
